import userSettings from "@profilog/front/localization/translations/cs/userSettings.json";
import patients from "@profilog/front/localization/translations/cs/patients.json";
import registration from "@profilog/front/localization/translations/cs/registration.json";
import records from "@profilog/front/localization/translations/cs/records.json";
import aboutService from "@profilog/front/localization/translations/cs/aboutService.json";
import footer from "@profilog/front/localization/translations/cs/footer.json";
import groups from "@profilog/front/localization/translations/cs/groups.json";
import header from "@profilog/front/localization/translations/cs/header.json";
import home from "@profilog/front/localization/translations/cs/home.json";
import loginDisplay from "@profilog/front/localization/translations/cs/loginDisplay.json";
import about from "@profilog/front/localization/translations/cs/about.json";
import aboutUs from "@profilog/front/localization/translations/cs/aboutUs.json";
import useCases from "@profilog/front/localization/translations/cs/useCases.json";
import persons from "@profilog/front/localization/translations/cs/persons.json";
import sharing from "@profilog/front/localization/translations/cs/sharing.json";
import cpz from "@profilog/front/localization/translations/cs/cpz.json";
import obefis from "@profilog/front/localization/translations/cs/obefis.json";
import extConnectors from "@profilog/front/localization/translations/cs/extConnectors.json";
import sps from "@profilog/front/localization/translations/cs/sps.json";
import userInitialization from "@profilog/front/localization/translations/cs/userInitialization.json";
import prescriptions from "@profilog/front/localization/translations/cs/prescriptions.json";
import icudemo from "@profilog/front/localization/translations/cs/icudemo.json";

import auth from "@profilog/misc/localization/translations/cs/auth.json";
import userSettingsShared from "@profilog/misc/localization/translations/cs/userSettings.json";
import apiResult from "@profilog/misc/localization/translations/cs/apiResult.json";
import global from "@profilog/misc/localization/translations/cs/global.json";
import recordsVisualization from "@profilog/misc/localization/translations/cs/recordsVisualization.json";
import caloricsTable from "@profilog/misc/localization/translations/cs/caloricsTable.json";
import apiStatusCheck from "@profilog/misc/localization/translations/cs/apiStatusCheck.json";
import communications from "@profilog/front/localization/translations/cs/communications.json";
import shCommunications from "@profilog/misc/localization/translations/cs/communications.json";
import shNotifications from "@profilog/misc/localization/translations/cs/notifications.json";
import feedback from "@profilog/misc/localization/translations/cs/feedback.json";
import ecg from "@profilog/misc/localization/translations/cs/ecg.json";
import surveys from "@profilog/surveys/localization/translations/cs/surveys.json";
import activitiesVisualization from "@profilog/misc/localization/translations/cs/activitiesVisualization.json";

export default {
    auth,
    userSettings: { ...userSettings, ...userSettingsShared },
    patients,
    registration,
    records,
    recordsVisualization,
    aboutService,
    footer,
    global,
    groups,
    header,
    home,
    loginDisplay,
    about,
    aboutUs,
    apiResult,
    useCases,
    persons,
    sharing,
    cpz,
    obefis,
    sps,
    caloricsTable,
    apiStatusCheck,
    extConnectors,
    userInitialization,
    communications,
    shCommunications,
    shNotifications,
    feedback,
    ecg,
    prescriptions,
    icudemo,
    surveys,
    activitiesVisualization,
};
